module.exports = __webpack_public_path__ + "static/media/img-interface-en.ac9b3fc6.png";